import { DOCUMENT, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject, OnInit, signal, ViewChild } from '@angular/core';

import { StaticFileHash } from '@scalefast/ecommerce-core';
import { EventTypeEnumerate } from '../../../../../core/enumerates';
import { GenericEventService } from '../../../../../shared/services';
import { AppModalComponent } from '../../../modal/modal.component';
import { AppSearchBarComponent } from '../search-bar/search-bar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-modal',
  templateUrl: 'search-modal.component.html',
  standalone: true,
  imports: [AppSearchBarComponent, StaticFileHash, AppModalComponent, NgClass],
})
export class AppSearchModalComponent implements OnInit {
  modalOpen = signal(false);
  @ViewChild('searchBar') searchBar: any;

  constructor(
    private genericEventService: GenericEventService,
    @Inject(DOCUMENT) private _doc: Document,
  ) {}

  ngOnInit(): void {
    this.genericEventService.subscribe(EventTypeEnumerate.APP_SEARCH_ITEM_CLICK, (event: any) => {
      this.close();
    });
  }

  close() {
    this.modalOpen.set(false);
    this._doc.body.classList.remove('modal-open');
  }

  open() {
    this.searchBar.cleanSearch();
    this._doc.body.classList.add('modal-open');
    this.modalOpen.set(true);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
